<template>
    <div class="tutorial">
        <HeaderSearch></HeaderSearch>
        <div class="content">
            <div class="list-first" v-show="!isShow">
                <div class="item" v-for="item in resData" :key="item.id" @click="handleClick(item.title, item.id)">
                    <div class="item-inner">
                        <i class="icon" :style="{background: 'url(' + item.filename + ')'}"></i>
                        <h4>{{ item.title }}</h4>
                        <p>{{ item.description }}</p>
                    </div>
                </div>
            </div>

            <div class="list-location" v-show="isShow">
                <div class="path">
                    <div class="title" @click="help()">帮助中心</div>
                    <i>></i>
                    <span @click="backUp">{{ props.title }}</span>
                    <!-- 第一步判断title是否存在，存在才渲染 -->
                    <template v-if="titleBack.title">
                        <i>></i>
                        <!-- 第二步判断subTitle是否存在，存在的才绑定事件，不存在的不绑定事件 -->
                        <template v-if="titleBack.subTitle">
                            <span @click="backUp">{{ titleBack.title }}</span>
                            <i>></i>
                            {{ titleBack.subTitle }}
                        </template>
                        <template v-else>
                            <span>{{ titleBack.title }}</span>
                        </template>
                    </template>

                </div>
            </div>
            <div class="list-inner" v-show="isShow">
                <div class="list-con">
                    <Menu :active-name="props.id" style="width: 170px;">
                        <div v-for="(item, index) in resData" :key="item.id" @click="select(item.id, index)">
                            <MenuItem :name="item.id" :to="'/HelpsContent?id='+ item.id + '&title=' + item.title">
                            {{ item.title }}
                            </MenuItem>
                        </div>
                    </Menu>
                </div>

                    <router-view @customEvent="backTitle"></router-view>

            </div>
        </div>
    </div>
</template>

<script>
import HeaderSearch from "./components/HeaderSearch";
import doPost from "@/pages/Helper/XHR.js";
export default {
  name: "Tutorial",
  components: { HeaderSearch },
  data() {
    return {
      isShow: false,
      resData: {},
      imageUrl: "",
      props: { title: "开始使用", id: "0" },
      titleBack: {}
    };
  },
  mounted() {
    if (this.$route.query.id) {
      this.isShow = true;
    } else if (sessionStorage.passback) {
      this.isShow = true;
      this.titleBack = JSON.parse(sessionStorage.passback);
    }
    this.$Loading.start()
    doPost({ action: "list_firstCategory" }, data => {
      if (data.data.length != 0) {
        data = data.data.map(item => {
          return item;
        });
      }
      this.resData = data;

      this.$nextTick(() => {
        if (this.$route.query.id) {
          this.props = this.$route.query;
        } else if (sessionStorage.passback) {
          let passback = JSON.parse(sessionStorage.passback);
          this.props.id = passback.id;
          this.props.title = passback.mainTitle;
          sessionStorage.passback = ""; // 清空数据
        }
        this.$Loading.finish()
      });
    });
  },
  destroyed () {
    this.$Loading.destroy()
  },
  methods: {
    handleClick(title, index) {
      this.isShow = true;
      this.props = { title: title, id: index };
      this.$router.push({
        path: "/HelpsContent",
        query: {
          title: title,
          id: index
        }
      });
    },
    help() {
      this.titleBack = {};
      this.isShow = false;
      this.$router.push({
        path: "/Tutorial"
      });
    },
    select(id, index) {
      this.props.index = id;
      this.props.title = this.resData[index].title;
      this.titleBack = {};
    },
    backTitle(msg) {
      this.titleBack = msg;
    },
    backUp() {
      this.titleBack = {};
      this.$router.push({
        path: "/HelpsContent",
        query: {
          id: this.props.index
        }
      });
    }
  }
};
</script>

<style lang='stylus' scoped>
.path * {
    color: #2bd3a0;
}

.path *:last-child {
    color: #666;
}

.content {
    height: auto;
    min-height: 590px;
    background: #fff;
    margin: 0 auto;

    .list-first {
        width: 65%;
        margin: 0 auto;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        padding: 80px 0px;
        .item {
            display: inline-block;
            width: 32%;
            font-size: 14px;
            color: #666;
            text-align: center;
            cursor: pointer;
            height: 4.04rem;
            position: relative;
            border: 1px solid #fff;
            transition: border-color 0.2s ease;
            border-radius: 2px;
            margin-bottom: 25px;

            &:hover {
                cursor: pointer;
                transform: scale(1.05);
                box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.1), 0px 2px 10px rgba(0, 0, 0, 0.1);
                transition: all ease-in-out 0.2s;
            }

            .item-inner {
                width: 100%;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
        }

        @media screen and (max-width: 1114px) {
            .item {
                width: 48%;
            }
        }

        @media screen and (max-width: 758px) {
            .item {
                width: 100%;
            }
        }

        .item .icon {
            display: block;
            width: 50px;
            height: 50px;
            margin: 0 auto;
            background-position: top center;
            background-repeat: no-repeat;
        }
    }

    h4 {
        font-family: 'MicrosoftYaHei';
        font-size: 14px;
        color: #333;
        letter-spacing: 2px;
        margin: 15px 0 10px 0;
    }

    p {
        color: #666;
        letter-spacing: 1px;
    }

    .list-location {
        width: 65%;
        margin: 0 auto;
        padding: 14px 0;
        border-bottom: 1px solid #eee;
        margin-bottom: 12px;

        .path {
            line-height: 20px;
        }

        .title {
            display: inline-block;
            color: #2bd3a0;
        }

        i {
            padding: 0 5px;
        }
    }

    .list-inner {
        width: 65%;
        height: auto;
        margin: 0 auto;
        display: flex;
        padding-bottom: 14px;

        .list-con {
            width: 170px;
            display: inline-block;
        }

        >>>.ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu) {
            color: #333;
            background: #eee;
        }

        .ivu-menu-vertical .ivu-menu-item, .ivu-menu-vertical {
            margin-bottom: 0.5em;
        }

        .ivu-menu-vertical .ivu-menu-item:hover, .ivu-menu-vertical .ivu-menu-submenu-title:hover {
            color: #333;
            background: #eee;
        }

        .ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu):after {
            background: #2bd3a0;
        }
    }
}

@media screen and (max-width: 758px) {
    .content .list-inner {
        padding: 0;
    }

    .content .list-inner .list-con {
        display: none;
    }
}
@media screen and (max-width: 456px)
    .content .list-location
        width 95%
    .content .list-inner
        width 90%
    .content .list-first
        width 100%
    .content .list-first .item
        width: 50%;

</style>




// WEBPACK FOOTER //
// src/pages/Tutorial/Tutorial.vue